var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteGrey(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.9541H11.5M26.833 18.4541L26.373 25.3541C26.196 28.0081 26.108 29.3351 25.243 30.1441C24.378 30.9531 23.047 30.9541 20.387 30.9541H19.613C16.953 30.9541 15.622 30.9541 14.757 30.1441C13.892 29.3351 13.803 28.0081 13.627 25.3541L13.167 18.4541M17.5 20.9541L18 25.9541M22.5 20.9541L22 25.9541",
    stroke: "#B3C0BD",
    style: (_ref2 = {
      stroke: "#B3C0BD"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.7020 0.7529 0.7412)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.9541H14.61C15.0124 15.9438 15.4024 15.8123 15.7289 15.5768C16.0554 15.3413 16.3033 15.0127 16.44 14.6341L16.474 14.5311L16.571 14.2401C16.654 13.9911 16.696 13.8671 16.751 13.7611C16.8592 13.5535 17.0145 13.3741 17.2045 13.2373C17.3944 13.1004 17.6138 13.01 17.845 12.9731C17.962 12.9541 18.093 12.9541 18.355 12.9541H21.645C21.907 12.9541 22.038 12.9541 22.155 12.9731C22.3862 13.01 22.6056 13.1004 22.7955 13.2373C22.9855 13.3741 23.1408 13.5535 23.249 13.7611C23.304 13.8671 23.346 13.9911 23.429 14.2401L23.526 14.5311C23.6527 14.9524 23.9148 15.3201 24.2717 15.5774C24.6285 15.8346 25.0603 15.967 25.5 15.9541",
    stroke: "#B3C0BD",
    style: (_ref3 = {
      stroke: "#B3C0BD"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.7020 0.7529 0.7412)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGrey);
export default __webpack_public_path__ + "static/media/delete_grey.09db1d9f.svg";
export { ForwardRef as ReactComponent };